// GET DATA - https://www.freecodecamp.org/news/how-to-use-the-firebase-database-in-react/

//import React from 'react';
// 3) HELMET - Add this import to each page
import React, { Fragment, useRef, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { NavLink } from 'react-router-dom';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from '../js/DrawSVGPlugin.js'; // Import the JavaScript file
import { MotionPathPlugin } from '../js/MotionPathPlugin.js'; // Import the JavaScript file
import { ScrambleTextPlugin } from '../js/ScrambleTextPlugin.min.js'; // Import the JavaScript file
//import { GlitchPlugin } from '../js/glitch-text-fx.js'; // Import the JavaScript file


import { SplitText } from "gsap/SplitText";



import heroimg_profile from '../images/heros/profile.webp'; // Tell webpack this JS file uses this image
// import images
import profile_photo from '../images/profile/profile-mark-hawkins-vector.jpg';


/* Images for final section */
import laptop_base from '../images/laptop/base.webp';
import laptop_screen from '../images/laptop/screen-1.webp';
import laptop_spacer from '../images/laptop/laptop-spacer.webp';


import hero_sailboat from '../images/profile/hero-sailboat.png';

import laptop_spotlight_fx1 from '../images/laptop/light-ray.svg';
import laptop_spotlight_fx2 from '../images/laptop/light-ray.svg';
import laptop_spotlight_fx3 from '../images/laptop/light-ray.svg';
import experience_profile_bg from '../images/profile/clouds-bg.webp';

import edu_book_1 from '../images/profile/gb-image-1.webp';
import edu_book_2 from '../images/profile/gb-image-1.webp';
import edu_book_3 from '../images/profile/gb-image-1.webp';
import edu_book_4 from '../images/profile/gb-image-4.webp';
import edu_book_5 from '../images/profile/gb-image-5.webp';
import edu_book_6 from '../images/profile/gb-image-6.webp';
import edu_book_7 from '../images/profile/gb-image-7.webp';
import edu_book_8 from '../images/profile/gb-image-8.webp';
import edu_book_9 from '../images/profile/gb-image-9.webp';
import edu_book_10 from '../images/profile/gb-image-10.webp';
import edu_book_11 from '../images/profile/gb-image-11.webp';
import edu_book_12 from '../images/profile/gb-image-12.webp';
import edu_book_13 from '../images/profile/gb-image-13.webp';
import edu_book_14 from '../images/profile/gb-image-14.webp';
import edu_book_15 from '../images/profile/gb-image-15.webp';
import edu_book_16 from '../images/profile/gb-image-16.webp';
import grid_spacer from '../images/profile/grid-spacer.png';



// Put your page code here dude

//Import that custom compnent ( Skill Gague) dude! 
// Step 1 dude-o-rama!
import { SkillGauge } from '../components/SkillGauge.jsx';
import { SkillGauge2 } from '../components/SkillGauge2.jsx';
// Step 2, add the tag where you want itto show up. Wow man so easy!
// <SkillGauge></SkillGauge>









const About = () => {



  const bgfx_ref = useRef();


  // =================== //
  // JS/GSAP ANIMATION 
  // ===================//
  useGSAP(() => {

      //Presets
    gsap.set(".profile-transition-curtain", { left: "-4000", top: "-4000" });
 

    // 1. Force scroll to top immediately
    if (typeof sScroll !== 'undefined') {
      sScroll.scrollTo(0, false);
    } else {
      window.scrollTo(0, 0);
    }
    // 2. Clear GSAP cached positions
    ScrollTrigger.clearScrollMemory();
    gsap.registerPlugin(DrawSVGPlugin, MotionPathPlugin, ScrollTrigger, ScrambleTextPlugin, SplitText);



    // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //
    // HERO ANIMATION
    // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx //
    let tl_hero_profile_fx = gsap.timeline({});
    let tl_hero_profile_fx2 = gsap.timeline({ repeat: -1, yoyo: true });

    gsap.set("#profile-hero-glasses-mask", { maskPosition: "0px -100px" });

    tl_hero_profile_fx.to(".hero-sailboat", {
      x: 600,
      duration: 180,
    });
    tl_hero_profile_fx2.to("#profile-hero-glasses-mask", {
      duration: 2,
      maskPositionX: "0px",
      maskPositionY: "-15px",
      ease: "power1.out"
    });


    // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    // HERO PLAY CONTROLLER 
    //  When scrolled past 800 pixels pasies, resumes when scollred back
    // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    window.addEventListener('scroll', function () {

      if (window.scrollY > 300) {
        tl_hero_profile_fx.pause();
        tl_hero_profile_fx2.pause();
      } else {
        tl_hero_profile_fx.play();
        tl_hero_profile_fx2.play();
      }
    });


    // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    // OPENING - PROFILE
    // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    gsap.set(".sec-about h2, .profile-id-photo", { x: "20px", opacity: 0 });
    gsap.set(".page-profile .sec-about-copy  strong, .page-profile .sec-about-copy p, .freelance-request-link", { y: "30px", opacity: 0 });
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    // DYNAMIC DELAY VALUE
    // this changes our delay based on inital applcation loadinbg vs page tp page transtions
    const dynamicDelay = window.isInitialPreload ? 6 : 2;

    // intial Animation.
    let profile_copy_tl = gsap.timeline({
      //  <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
      // Dynamic Dealy Value - add onComplete code to all starter timelines.
      onComplete: () => { window.isInitialPreload = false; }
    });

    profile_copy_tl
      .to(".page-profile .sec-about  h2", { duration: 0.5, opacity: 1, x: '0px' }, `+=${dynamicDelay}`)
      .to(".profile-id-photo", { duration: 0.5, opacity: 1, x: '0px' })
      .to(".page-profile .sec-about-copy  strong", { duration: 0.5, opacity: 1, y: '0px', delay: -1 })
      .to(".page-profile .sec-about-copy  p", { duration: 0.5, opacity: 1, y: '0px' })
      .to(".freelance-request-link", { duration: 0.5, opacity: 1, y: '0px' });



    // Photo Txt border Effect
    // ------------------------------- //
    let tl_profile_outline = gsap.timeline({
      scrollTrigger: {
        trigger: ".sec-about",
        start: "top center-=5%",
        scrub: false,
        //pin: ".sec-about",
        end: "bottom+=100px",
        markers: false
      }
    })
      .to(".profile-img", { duration: 0.2, opacity: 1, onComplete: textOutlineFX });


    // outline text around photo 
    let tl_pro_tags;
    function textOutlineFX() {
      for (let i = 1; i < 9; i++) {
        tl_pro_tags = gsap.timeline();
        tl_pro_tags.to('.profile-tags .profile-tag-' + i, {
          motionPath: {
            path: ".text-path",
            align: ".text-path",
            alignOrigin: [0, 0.5],
            //autoRotate: -90,
            autoRotate: true,
            immediateRender: true,
            start: (i * 12), // 0.2 * 5 = 1 - so 0.07 * 7 = 1( divide 100 by 7.)
            end: (i * 0.12) + 1  // 1 is the end
          },
          opacity: 1,
          //repeat: -1,
          duration: 1,
          ease: "power4.out",
          stagger: 1.5,
          delay: i * 0.10,
        })
      }
    }




    // **********************************//
    // MATCH MEDIA MOBILE 
    // **********************************//
    let mm_profile = gsap.matchMedia();
    // Desktop animation
    mm_profile.add("(min-width: 800px)", () => {



      // ========================== //
      // DESIGN & DEVELOPMENT section 
      // ========================== //

      // Background Parallax Animation On Scroll
      // ----------------------------//	
      // presets
      gsap.set("#lens-flare-1, #lens-flare-2, #lens-flare-3", { scale: 0.8, opacity: 0 });

      /* Parallax Background */
      let tl_expbg = gsap.timeline({
        scrollTrigger: {
          trigger: ".profile-experience-list",
          start: "top top+=10%", // Fixed 'np' typo
          end: "bottom+=4000px",
          scrub: true
        }
      });

      tl_expbg.to(".profile-experience-list", {
        duration: 12, // Fixed typo
        backgroundPosition: "50% 100%",
        ease: "none"
      });
      tl_expbg.to("#lens-flare-1", {
        scale: 1,
        opacity: 1,
        duration: 6,
        xPercent: 23,
        yPercent: -17,
        delay: -12
      });
      tl_expbg.to("#lens-flare-2", {
        scale: 1,
        opacity: 1,
        duration: 6,
        xPercent: 23,
        yPercent: 17,
        delay: -11
      });
      tl_expbg.to("#lens-flare-3", {
        scale: 1,
        opacity: 1,
        duration: 6,
        xPercent: 23,
        yPercent: 17,
        delay: -10
      });



      /* Flip Card Interactive */
      /* Flip Card Interactive */
      let tlcardslide = gsap.timeline({});

      tlcardslide.to(".flip-card", {
        duration: 6,
        xPercent: -1150, // -1150
        ease: "none",
        scrollTrigger: {
          trigger: ".sec-creative-exp",
          start: "top top+=10%",
          scrub: 1,
          pin: ".sec-creative-exp",
          end: "bottom+=4000px",
          //snap: (8, 1),
        },
        onUpdate: checkPos
      });


      // AUTO FLIP  BY CENTER POSITION
      // ================================ //
      function checkPos() {
        let screenWidth = Math.round(window.innerWidth);
        let middleScreen = screenWidth / 2; // get the center of screen regardles sof size
        let rightTrigger = middleScreen + 20; // set a perimiter 200 pxiles before ( eg; animate large )
        let leftTrigger = middleScreen - 20;  // set a perimiter 200 pxiles after ( eg; animate small )

        let currentX_1 = document.querySelector('.fc1').getBoundingClientRect().left;
        let currentX_2 = document.querySelector('.fc2').getBoundingClientRect().left;
        let currentX_3 = document.querySelector('.fc3').getBoundingClientRect().left;
        let currentX_4 = document.querySelector('.fc4').getBoundingClientRect().left;
        let currentX_5 = document.querySelector('.fc5').getBoundingClientRect().left;
        let currentX_6 = document.querySelector('.fc6').getBoundingClientRect().left;
        let currentX_7 = document.querySelector('.fc7').getBoundingClientRect().left;
        let currentX_8 = document.querySelector('.fc8').getBoundingClientRect().left;

        // if less then rightTrigger value, flip it! - done :)
        if (Math.round(currentX_1) <= rightTrigger) {
          gsap.to(".fc1 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        } else
          if (Math.round(currentX_1) > rightTrigger) {
            gsap.to(".fc1 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
          }
        if (Math.round(currentX_2) <= rightTrigger) {
          gsap.to(".fc2 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        } else
          if (Math.round(currentX_2) > rightTrigger) {
            gsap.to(".fc2 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
          }
        if (Math.round(currentX_3) <= rightTrigger) {
          gsap.to(".fc3 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        }
        if (Math.round(currentX_3) > rightTrigger) {
          gsap.to(".fc3 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
        }
        if (Math.round(currentX_4) <= rightTrigger) {
          gsap.to(".fc4 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        } else
          if (Math.round(currentX_4) > rightTrigger) {
            gsap.to(".fc4 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
          }
        if (Math.round(currentX_5) <= rightTrigger) {
          gsap.to(".fc5 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        } else
          if (Math.round(currentX_5) > rightTrigger) {
            gsap.to(".fc5 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
          }
        if (Math.round(currentX_6) <= rightTrigger) {
          gsap.to(".fc6 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        } else
          if (Math.round(currentX_6) > rightTrigger) {
            gsap.to(".fc6 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
          }
        if (Math.round(currentX_7) <= rightTrigger) {
          gsap.to(".fc7 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        } else
          if (Math.round(currentX_7) > rightTrigger) {
            gsap.to(".fc7 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
          }
        if (Math.round(currentX_8) <= rightTrigger) {
          gsap.to(".fc8 .flip-card-cont", { duration: 1, rotateY: 180, delay: 0 });
        } else
          if (Math.round(currentX_8) > rightTrigger) {
            gsap.to(".fc8 .flip-card-cont", { duration: 1, rotateY: 0, delay: 0 });
          }
      }

    }); // END of MATCH MEDIA MOBILE =  800 <<< XXXXXXXXXXXXX






    // =========================================================== //
    // BLUR TEXT HEADINGS EFFECT ( h1, H2, H3)
    // https://codepen.io/GreenSock/pen/NWKjEBG?editors=0010
    // =========================================================== //
    const blurProperty = gsap.utils.checkPrefix("filter"),
      blurExp = /blur\((.+)?px\)/,
      getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

    gsap.registerPlugin({
      name: "blur",
      get(target) {
        return +(getBlurMatch(target)[1]) || 0;
      },
      init(target, endValue) {
        let data = this,
          filter = gsap.getProperty(target, blurProperty),
          endBlur = "blur(" + endValue + "px)",
          match = getBlurMatch(target)[0],
          index;
        if (filter === "none") {
          filter = "";
        }
        if (match) {
          index = filter.indexOf(match);
          endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
        } else {
          endValue = filter + endBlur;
          filter += filter ? " blur(0px)" : "blur(0px)";
        }
        data.target = target;
        data.interp = gsap.utils.interpolate(filter, endValue);
      },
      render(progress, data) {
        data.target.style[blurProperty] = data.interp(progress);
      }
    });
    const quotes = document.querySelectorAll(".h2-Title");
    quotes.forEach((quote) => {
      // Reset if needed
      if (quote.anim) {
        quote.anim.progress(1).kill();
        quote.split.revert();
      }
      quote.split = new SplitText(quote, {
        type: "lines,words,chars",
        linesClass: "split-line"
      });
      gsap.set(quote.split.chars, { opacity: 1 });
      // Set up the anim
      quote.anim = gsap.from(quote.split.chars, {
        scrollTrigger: {
          trigger: quote,
          // toggleActions: "restart pause resume reverse",
          start: "top 30%",
          end: "bottom+=1000px",
          //markers: { startColor: "#dfdcff", endColor: "transparent" }
        },
        duration: 0.2,
        ease: "circ.out",
        opacity: 0,
        blur: 4,
        scale: 1.5,
        stagger: 0.03
      });
    });












    // **********************************//
    // MATCH MEDIA MOBILE 
    // **********************************//
 
    // Desktop animation
    //mm_profile3.add("(min-width: 800px)", () => {



      // EDUCATION & KNOWLEDGE SECTION - Laptop
// -------------------------------------------------//

// Scoped selectors to avoid breaking other paths on your page
gsap.set(".education-pin-wrapper path", { drawSVG: false });
gsap.set("#s4c, #s3c, #s2a", { opacity: 0 });
gsap.set("#stripe-1, #s2b, #s2c, #s3a, #s3b, #s4a, #s4b, #stripe-5", { opacity: 0 });
gsap.set("#initials-bg", { drawSVG: 0, fill: "none" });
gsap.set('.signal-hoop-1, .signal-hoop-2, .signal-hoop-3', { scale: 0, transformOrigin: "center center" });
gsap.set('.screen-mhd-logo', { opacity: 0, scale: 0.8, transformOrigin: "center center" });
gsap.set(".laptop-container", { perspective: 1350, autoAlpha: 0 });
gsap.set(".screen", { transformOrigin: "50% 100%", rotateX: -77 });
gsap.set('.edu-paragraph', { opacity: 0, y: 20 }); // Fixed 'alpha' to 'opacity'

// Calculate a fixed height on load so mobile address bars don't trigger resizes mid-scroll
const baseHeight = window.innerHeight; 

 let mm_profile3 = gsap.matchMedia();

let tl_laptop = gsap.timeline({
  scrollTrigger: {
    trigger: ".education-and-other-talents",
    pin: ".education-and-other-talents",
    start: "top top+=10%",
    end: () => `+=${baseHeight * 3}`, 
    scrub: true,
    pinSpacing: true,
    anticipatePin: 1, 
    invalidateOnRefresh: true,
    markers: false,
  }
});




tl_laptop
  .to(".laptop-container", {
    duration: 2,
    autoAlpha: 1,
     onStart:animationBooks
  })
  .to(".screen", {
    duration: 2,
    rotateX: 0,
    ease: "expo.out",
    transformOrigin: "50% 100%",
    delay: -2
  })
    .to('.edu-paragraph', { duration: 1, y: "0px", opacity: 1, transformOrigin: "center center", ease: "power4.out", delay: -0.75 })
  .to('.signal-hoop-3', { duration: 1, scale: 1, opacity: 0, transformOrigin: "center center", ease: "power4.out" })
  .to('.signal-hoop-2', { duration: 1, scale: 1, opacity: 0, transformOrigin: "center center", ease: "power4.out", delay: -0.75 })
  .to('.signal-hoop-1', { duration: 1, scale: 1, opacity: 0, transformOrigin: "center center", ease: "power4.out", delay: -0.75 })
  .to('.screen-mhd-logo', { duration: 1, scale: 1, opacity: 1, transformOrigin: "center center", ease: "power4.out", delay: -0.75 })
  .to("#initials-bg", {
    duration: 1,
    drawSVG: "100%",
    ease: "power1.inOut"
  })
  .fromTo("#initials-bg",
    { fill: "transparent" },
    { fill: "#ffffff", duration: 1, delay: -0.5 }
  )
  .to("#initials-bg", {
    duration: 1,
    strokeOpacity: 0,
    delay: -0.5
  })
  .to(["#stripe-1", "#s2b", "#s2c", "#s3a", "#s3b", "#s4a", "#s4b", "#stripe-5"], {
    duration: 0.2,
    opacity: 1,
    ease: "power1.inOut",
    stagger: 0.1,
    delay: -0.5,
  });


function animationBooks(){
   gsap.to(".gb-box", {
      rotationY: 180,
      duration: 0.5,
      ease: "power2.inOut",
      transformOrigin: "center center",
      stagger: 0.2, // This will now stagger each box by 0.2 seconds
    })
}




// ADD YOUR NEW ANIMATION HERE BUT NEED TO REARANGE IT TO FIRST playing!
// <<<<<<<<<<<<<<<<<================================================================= <<<<



    //}); // END of MATCH MEDIA DESKTOP =  800 <<< XXXXXXXXXXXXX 







 










    /// **********************************//
    // MATCH MEDIA MOBILE  - Design & Development Experience
    // **********************************//
    let mm_profile2 = gsap.matchMedia();
    // Desktop animation
    mm_profile2.add("(max-width: 799px)", () => {


      const cards = document.querySelectorAll('.flip-card');
      cards.forEach((card) => {
        // Target the inner element that contains the front and back faces
        const cardInner = card.querySelector('.flip-card-cont');
        let isFlipped = false;

        card.addEventListener('click', () => {
          isFlipped = !isFlipped;

          // Animate the inner container
          gsap.to(cardInner, {
            rotateY: isFlipped ? 180 : 0,
            duration: 0.6,
            ease: 'power2.inOut'
          });
        });
      });


    }); // END OF MM Mobile







    //<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< ===================================================== Update Scrolltrigger bug 8-24-2026  
    // --- AT THE BOTTOM OF useGSAP ---
    // 3. Wait 1 render frame for CRA to paint, re-verify 0px, and refresh markers
    requestAnimationFrame(() => {
      if (typeof sScroll !== 'undefined') {
        sScroll.scrollTo(0, false);
      } else {
        window.scrollTo(0, 0);
      }
      ScrollTrigger.refresh();
    });



  }, { scope: bgfx_ref });
  // End of useGSAP






  // =================== //
  // HTML OUTPUT
  // ===================//
  return (

    <main className="page-content page-id_profile" data-page-id="profile" ref={bgfx_ref}>

      <HelmetProvider>
        <Fragment>
          <Helmet>
            <title>Profile | Mark Hawkins</title>
            <meta name="description" content="Profile of Sr graphic designer and web developer for over 24 yeaars, Mark Hawkins" />
          </Helmet>
        </Fragment>
      </HelmetProvider>

      <svg version="1.1" className="profile-transition-curtain transition-curtain" x="0px" y="0px" viewBox="0 0 191 191" xmlSpace="preserve">
        <path className="st0" d="M95.5,190.5c-52.4,0-95-42.6-95-95s42.6-95,95-95s95,42.6,95,95S147.9,190.5,95.5,190.5z" />
        <path className="st1" d="M95.5,1C147.6,1,190,43.4,190,95.5S147.6,190,95.5,190S1,147.6,1,95.5S43.4,1,95.5,1 M95.5,0
	C42.8,0,0,42.8,0,95.5S42.8,191,95.5,191S191,148.2,191,95.5S148.2,0,95.5,0L95.5,0z"/>
      </svg>

      <div className="hero-container-wrap">
        <div className='hero-container'>
          <div className="hero-mask">

            <div className='mask-svg'>
              <svg viewBox="0 0 0 0" height="0" width="0">
                <defs>
                  <clipPath id="clipping" clipPathUnits="objectBoundingBox" transform="scale(0.00099, 0.00105)">
                    <path id="dotmask" d="M853,0c0,357.9-290.1,648-648,648c-71.6,0-140.6-11.6-205-33.1v158.6C65.4,790.8,134.1,800,205,800
			c441.8,0,800-358.2,800-800H853z"/>
                    <path id="hoopmask" d="M0,0v501.1c63.2,25.9,132.4,40.2,205,40.2c298.9,0,541.3-242.3,541.3-541.3H0z" />
                  </clipPath>
                </defs>
              </svg>
            </div>






            <div className='heroimage'>

              <svg id="profile-hero-glasses-mask" baseProfile="tiny" version="1.2" viewBox="0 0 2400 1750">
                <path id="eye-glass-mask-1" d="M253,739s54.5-54.5,155-68,144.5-12,159-8,53.6,19.5,64,52,18,55.5,7,84-32.5,81-109,98-124,23-146,21-53,.5-80-43-66.5-99.5-50-136Z" strokeMiterlimit="10" />
                <path id="eye-glass-mask-2" d="M755,660.2s14.5,37.3,50,72.8,73,70,89,75,66.5,31.5,126,27,75-7,84-24-23-86.5-27-95-37-52.5-61-64-68.5-29.5-111-30-51.2-5.7-100,8-42,18.4-50,30.2Z" strokeMiterlimit="10" />
              </svg>


              <img src={hero_sailboat} className="hero-sailboat" />
              <img src={heroimg_profile} alt="profile background hero - picture of sunglasses on sand with backdrop of beach" />

            </div>




          </div>

          <div className='hero-text'>
            <div className="page-h1">
              <h1 style={{ opacity: 0, visibility: 'hidden' }}>Profile</h1>
              <div className="h1-accent"><span></span></div>
            </div>
            <strong>Graphic Designer / Web Developer</strong>
          </div>
        </div>
      </div>








      <div className="content page-profile">

        <section className="sec-about">

          <h2 className="h2-first">About</h2>

          <div className="sec-about">


            <div className="columns">
              <div className="col-50 sec-about-copy">

                <strong>Hi, I’m Mark Hawkins, a Miami-based Sr. Graphic Designer, Full-Stack Developer, and Animator.</strong>
                <p className="p-sect-1">
                  With over 20 years of experience,
                  I specialize in bridging the gap between creative vision and technical execution. Throughout my career, I’ve contributed
                  to in-house teams at Interval International, BioTissue, Stratosphere Designs, and Perry Ellis International. This site is a
                  curated look at the projects that define my execution for high-impact design and client success. I'm truly passionate about my work and the journey.
                </p>
                <NavLink className="colorborderfx freelance-request-link" to="/contact">Hire Me For Your Project</NavLink>

              </div>

              <div className="col-50 profile-image">

                <div className="profile-id-photo p-sect-2">
                  <img className="profile-img" src={profile_photo} alt="Picture of Mark Hawkins" />


                  <svg id="profile-mh-text-paths" version="1.2" viewBox="0 0 1061 1060">
                    <path className="text-path" d="M1061,1060H0V0h1061v1060Z" fill="none" />
                  </svg>

                  <div className="profile-tags">
                    <div className="profile-tag-1">Constructor</div>
                    <div className="profile-tag-2">Coceptulizer </div>
                    <div className="profile-tag-3">Visualizer </div>
                    <div className="profile-tag-4">Coder</div>
                    <div className="profile-tag-5">Programmer</div>
                    <div className="profile-tag-6">Artist</div>
                    <div className="profile-tag-7">Illustrator</div>
                    <div className="profile-tag-8">Animator</div>
                  </div>



                </div>








              </div>

            </div>
          </div>
        </section>



















        <section className="sec-creative-exp">
          <h2><span className="h2-Title">Design &amp; Development Experience</span></h2>

          <div className="profile-experience-list">



            <div className="mobile-ui-alert">


              <svg id="scroll-arrow" version="1.1" viewBox="0 0 40 200">
                <polygon id="arrow" points="8.8 100 40 21.9 40 0 0 100 40 200 40 178.1 8.8 100" />
              </svg>


            </div>


            <div className="flip-card-container">

              <div className="flip-card fc1">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc1">

                    <div className="fc-icon">
                      <svg id="graphic_design_icon" viewBox="0 0 200 150">
                        <path id="brush_handle" d="M145.4,29.8L7,62.8c-.5,0-1.2-.3-1.4-1.1h0c-.2-.7,0-1.5.6-1.6L142.6,19.3c2.2.7,3.4,9.8,2.8,10.4h-.1.1Z" />
                        <path id="bursh_tip" d="M155.7,9c-5.9,1.5-10.1,4.7-11.1,8.9,0,0,1.2,0,2.4,5.5,1.3,5.5,0,5.5,0,5.5,3,3.1,8.9,3,14.8,1.3s32.9-19.7,32.7-20.2c-.2-.8-33.4-2.2-38.8-.8v-.2Z" />
                        <g id="color_slots">
                          <path d="M102.7,50c-41,0-74.3,24.3-74.3,54.2s54.8,60.7,64.1,15.8c3.1-14.7,20.4-15.8,27.5,4.5,12.2,34.9,57,2.7,57-20.4s-33.3-54.2-74.3-54.2h0ZM67,99.8c-4.2,2.7-10.9-.1-15-6.4-4.1-6.2-4-13.6,0-16.3,4.2-2.7,10.9.1,15,6.4,4.1,6.2,4,13.6,0,16.3ZM86.4,87.7c-4.7,1.6-10.5-3-12.9-10-2.3-7.1-.4-14.1,4.3-15.7,4.7-1.6,10.5,3,12.9,10s.4,14.1-4.3,15.7ZM108.6,85.5c-5,0-9.1-6.1-9.1-13.6s4-13.6,9.1-13.6,9.1,6.1,9.1,13.6-4,13.6-9.1,13.6ZM127.3,90c-4.3-2.5-4.7-9.8-1.1-16.2,3.8-6.5,10.3-9.7,14.7-7.3,4.3,2.5,4.7,9.8,1.1,16.2-3.8,6.5-10.3,9.7-14.7,7.3h0ZM158.6,102.5c-6.1,4.3-13.4,4.5-16.3.5-2.8-4.1-.3-10.9,5.8-15.2s13.4-4.5,16.3-.5c2.8,4.1.3,10.9-5.8,15.2Z" />
                        </g>
                      </svg>
                    </div>
                    <span className="fc-title">Graphic Design</span>


                  </div>
                  <div className="flip-card-back">
                    <h3>Graphic Design</h3>
                    <p>Experienced with creating email designs, web layouts, hero designs, UI designs, infographics, icons, logos, brochures, business cards, product labels, banners, posters, flyers and t-shirt print designs.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num">23+</div>
                      Years' Experience
                    </div>


                  </div>
                </div>
              </div>



              <div className="flip-card fc2">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc2">


                    <div className="fc-icon">
                      <svg id="web_development" version="1.1" viewBox="0 0 200 120">
                        <g id="outline_screens">
                          <polygon className="st0" points="57.6 97.7 91 97.7 91 104.7 62.2 104.7 62.2 112.6 148.6 112.6 148.6 104.7 119.8 104.7 119.8 97.7 166.2 97.7 166.2 91.9 57.6 91.9 57.6 97.7" />
                          <path className="st0" d="M195.7,62.3h-11V12.2h-.4c0-2.8-2.3-5-5-5H31.4c-2.8,0-5,2.3-5,5v27.5H3.9C1.8,39.7,0,41.4,0,43.6v71.2C0,117,1.6,118.7,3.9,118.7h49.7c2.1,0,3.9-1.6,3.9-3.9V43.5c0-2.1-1.8-3.8-3.9-3.8h-21.4v-21.9c0-2.8,2.3-5,5-5h136.8c2.8,0,5,2.3,5,5v44.4h-9.4c-1.8,0-3.3,1.5-3.3,3.3v49.8c0,1.8,1.5,3.3,3.3,3.3h26.2c1.8,0,3.3-1.5,3.3-3.3v-49.8c0-1.8-1.5-3.3-3.3-3.3h0ZM48.1,45.4c2.1,0,3.9,1.6,3.9,3.9v60h-.1c0,2.1-1.6,3.9-3.9,3.9H9.6c-2.1,0-3.9-1.6-3.9-3.9v-60c0-2.1,1.6-3.9,3.9-3.9h38.4ZM193.2,109.7c0,1.8-1.5,3.3-3.3,3.3h-14.9c-1.8,0-3.3-1.5-3.3-3.3v-38.7c0-1.8,1.5-3.3,3.3-3.3h14.9c1.8,0,3.3,1.5,3.3,3.3v38.7Z" />
                        </g>
                        <rect id="wd_screen_1" className="st0" x="71.6" y="28.8" width="72.6" height="7.5" />
                        <rect id="wd_screen_2" className="st0" x="71.6" y="40.9" width="36.5" height="32.4" />
                        <rect id="wd_screen_3" className="st0" x="111.6" y="41.4" width="31.9" height="13" />
                        <rect id="wd_screen_4" className="st0" x="111.6" y="58.8" width="31.9" height="14.3" />
                      </svg>
                    </div>
                    Website Development

                  </div>
                  <div className="flip-card-back">

                    <h3>Website <span>Development</span></h3>
                    <p>Experienced with custom coding using HTML, CSS, JavaScript, PHP, JSON, AJAX, MySQL, Liquid, TypeScript for creating static websites, interactive websites and  dynamic websites.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num">22+</div>
                      Years' Experience
                    </div>
                  </div>
                </div>
              </div>



              <div className="flip-card fc3">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc3">

                    <div className="fc-icon">
                      <svg id="wordpress_logo" version="1.1" viewBox="0 0 200 130">
                        <path id="wp_logo" className="st0" d="M51,69c0,19.3,11.2,36,27.5,43.9l-23.5-63.8c-2.8,6.1-4.3,12.8-4.3,19.9h.2ZM133,66.6c0-6.1-2.2-10.2-4-13.5-2.4-4-4.8-7.5-4.8-11.5s3.5-8.8,8.3-8.8.4,0,.5,0c-8.8-8-20.3-12.8-33.1-12.8s-32.2,8.8-40.9,22h3.1c5.1,0,13.1-.5,13.1-.5,2.7,0,3,3.6.4,4,0,0-2.7.4-5.6.5l17.8,53,10.7-32.2-7.5-21c-2.7,0-5.1-.5-5.1-.5-2.7,0-2.3-4.3.4-4,0,0,8.1.5,12.8.5s13.1-.5,13.1-.5c2.7,0,3,3.6.4,4,0,0-2.7.4-5.6.5l17.5,52.5,4.9-16.4c2.1-6.7,3.7-11.5,3.7-15.6h0v.2h-.2,0ZM100.8,73.3l-14.7,42.7c4.4,1.2,9.1,2.1,13.8,2.1s11.2-1,16.3-2.8c0-.3-.3-.5-.4-.8l-15.1-41.2h0ZM142.9,45.5c.3,1.6.4,3.2.4,5.1,0,4.9-.9,10.5-3.6,17.5l-14.8,43.2c14.5-8.5,24.4-24.2,24.4-42.2s-2.2-16.5-6.1-23.5h-.2ZM100,12c-31.5,0-57,25.5-57,57s25.5,57,57,57,57-25.5,57-57-25.5-57-57-57h0ZM100,123.5c-29.9,0-54.5-24.4-54.5-54.5S69.8,14.5,100,14.5s54.5,24.5,54.5,54.5-24.4,54.5-54.5,54.5h0Z" />
                      </svg>
                    </div>

                    WordPress Development

                  </div>
                  <div className="flip-card-back">

                    <h3>WordPress <span>Development</span></h3>
                    <p>Experienced with WordPress custom theme design and development that's built from the ground up and optimized with custom code, requiring less plugins, for optimal functionality and performance.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num">12+</div>
                      Years' <span>Experience</span>
                    </div>
                  </div>
                </div>
              </div>




              <div className="flip-card fc4">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc4">

                    <div className="fc-icon">
                      <svg id="ecommerce_icon" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 200 135">
                        <g id="cart-wheels">
                          <path className="st0" d="M79.7,111.1c-5.7,0-10.4,4.7-10.4,10.4s4.7,10.4,10.4,10.4,10.4-4.7,10.4-10.4-4.7-10.4-10.4-10.4ZM79.7,124.9c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5-1.6,3.5-3.5,3.5Z" />
                          <path className="st0" d="M137.4,111.1c-5.7,0-10.4,4.7-10.4,10.4s4.7,10.4,10.4,10.4,10.4-4.7,10.4-10.4-4.7-10.4-10.4-10.4ZM137.4,124.9c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5,3.5,1.6,3.5,3.5-1.6,3.5-3.5,3.5Z" />
                        </g>
                        <g id="cart">
                          <path className="st0" d="M178.3,37.8c.8-1.3,0-2.9-1.6-2.9H57c-.9,0-1.6-.6-1.8-1.4l-2.7-11c-.2-.8-1-1.4-1.8-1.4h-24.3c-1,0-1.9.8-1.9,1.9v3.1c0,1,.8,1.9,1.9,1.9h17.4c.9,0,1.6.6,1.8,1.4l13.5,54,6.5,22.9c.2.8,1,1.4,1.8,1.4h79.8c1,0,1.9-.8,1.9-1.9v-3.1c0-1-.8-1.9-1.9-1.9h-72.9c-.8,0-1.6-.6-1.8-1.4l-3.9-13.5c-.3-1.2.6-2.4,1.8-2.4h77.6c.6,0,1.2-.3,1.6-.9l28.7-44.7h0ZM116.3,62.6h13.5c1,0,1.9.8,1.9,1.9v10.1c0,1-.8,1.9-1.9,1.9h-13.5c-1,0-1.9-.8-1.9-1.9v-10.1c0-1,.8-1.9,1.9-1.9ZM105.5,76.5h-13.5c-1,0-1.9-.8-1.9-1.9v-10.1c0-1,.8-1.9,1.9-1.9h13.5c1,0,1.9.8,1.9,1.9v10.1c0,1-.8,1.9-1.9,1.9ZM140.5,62.6h8.8c1.5,0,2.4,1.6,1.6,2.9l-6.2,10.1c-.3.6-1,.9-1.6.9h-2.6c-1,0-1.9-.8-1.9-1.9v-10.1c0-1,.8-1.9,1.9-1.9ZM163.7,44.7l-6.2,10.1c-.3.6-1,.9-1.6.9h-15.4c-1,0-1.9-.8-1.9-1.9v-10.1c0-1,.8-1.9,1.9-1.9h21.6c1.5,0,2.4,1.6,1.6,2.9h0ZM131.7,43.7v10.1c0,1-.8,1.9-1.9,1.9h-13.5c-1,0-1.9-.8-1.9-1.9v-10.1c0-1,.8-1.9,1.9-1.9h13.5c1,0,1.9.8,1.9,1.9ZM107.4,43.7v10.1c0,1-.8,1.9-1.9,1.9h-13.5c-1,0-1.9-.8-1.9-1.9v-10.1c0-1,.8-1.9,1.9-1.9h13.5c1,0,1.9.8,1.9,1.9ZM59.7,41.9h21.7c1,0,1.9.8,1.9,1.9v10.1c0,1-.8,1.9-1.9,1.9h-19.1c-.9,0-1.6-.6-1.8-1.4l-2.5-10.1c-.3-1.2.6-2.3,1.8-2.3h-.1ZM64.9,62.6h16.5c1,0,1.9.8,1.9,1.9v10.1c0,1-.8,1.9-1.9,1.9h-13.9c-.9,0-1.6-.6-1.8-1.4l-2.5-10.1c-.3-1.2.6-2.3,1.8-2.3h0Z" />
                        </g>
                        <g id="cart-numbers">
                          <path className="st0" d="M78.6,22.2c1.5-3.6,5-5.6,12-2.6,7.1,3,8.1,7,6.5,10.6s-5,5.6-12.1,2.5-7.9-6.9-6.4-10.4h0ZM94.1,28.8c1.3-3-3.1-4.8-5.1-5.7s-6.2-2.7-7.5.3,3.1,4.8,5,5.6,6.4,2.7,7.6-.2Z" />
                          <path className="st0" d="M104.7,29.1l-3.7,1.2-3.9-12-4.6,1.5-.9-2.8c2.6-.8,4.7-2.5,4.2-5.4l3-1,6,18.4h0Z" />
                          <path className="st0" d="M73.6,33.5l-3.7-1.3,4-11.9-4.6-1.6.9-2.8c2.6.9,5.3.8,6.6-1.8l3,1s-6.2,18.4-6.2,18.4Z" />
                          <path className="st0" d="M116.2,15.6c3.6,1.4,5.8,4.9,3,11.9-2.8,7.2-6.7,8.3-10.3,6.9s-5.7-4.8-2.9-12c2.7-7,6.7-8.1,10.2-6.8ZM110.1,31.4c3,1.2,4.7-3.3,5.5-5.3.7-1.9,2.4-6.3-.5-7.5s-4.7,3.3-5.4,5.2-2.5,6.5.4,7.6Z" />
                          <path className="st0" d="M121.6,31.6l-3.1-2.5,7.9-9.8-3.8-3.1,1.9-2.3c2.1,1.8,4.7,2.6,6.8.6l2.4,2-12.2,15.1h0Z" />
                          <path className="st0" d="M131.1,34.9h6.4c-1.1-.6-2.1-1.5-2.8-2-1.6-1.3-5.2-4.3-3.2-6.7,2.1-2.5,5.7.6,7.3,1.9,1.7,1.4,5.3,4.4,3.3,6.9h3.8c1.1-2.7.2-6.1-4.5-10-5.8-4.8-9.8-3.9-12.3-.9-2.3,2.7-2.6,6.5,2.1,10.9h-.1Z" />
                          <path className="st0" d="M151.6,23.1l2.5,11.8h2.5l1.5-.3-4-19-3.1.6c.2,3-2.1,4.4-4.8,4.9l.6,2.9,4.8-1h0Z" />
                        </g>
                      </svg>

                    </div>

                    Shopping Cart Development

                  </div>
                  <div className="flip-card-back">
                    <h3>Shopping <span>Cart Development</span></h3>
                    <p>Experienced with WooCommerce and Shopify shopping cart checkout, theme design and development with setup of customized payment processing, shipping, discounts, SEO, and product attributes.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num">9+</div>
                      Years' <span>Experience</span>
                    </div>
                  </div>
                </div>
              </div>




              <div className="flip-card fc5">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc5">


                    <div className="fc-icon">
                      <svg id="react_app_development_icon" version="1.1" viewBox="0 0 200 145">
                        <g id="GEARS">
                          <g id="gear-1">
                            <path d="M103.8,99.3l-6.5-3.5c-.7-.5-1.2-1.2-1.2-1.8v-3.6c0-.9.5-1.6,1.2-2.1l6.5-3.7c.7-.5,1.2-1.4,1.2-2.3-.5-2.3-1.2-4.6-1.8-6.7-.2-.9-1.2-1.4-2.1-1.4l-7.4.2c-.9,0-1.6-.5-1.8-1.2-.7-1.2-1.2-2.3-1.8-3.2-.5-.7-.5-1.6,0-2.3l3.7-6.5c.5-.7.5-1.8-.2-2.5-1.6-1.6-3.2-3.5-5.1-4.8-.7-.7-1.6-.7-2.5-.2l-6.5,3.9c-.7.5-1.6.5-2.3,0-1.2-.7-2.3-1.4-3.5-1.8-.7-.5-1.2-1.2-1.2-1.8v-7.4c0-.9-.7-1.6-1.4-2.1-2.3-.7-4.4-1.4-6.7-1.6-.9-.2-1.8.2-2.3,1.2l-3.5,6.5c-.5.7-1.2,1.2-1.8,1.2h-3.6c-.9,0-1.6-.5-2.1-1.2l-3.7-6.5c-.5-.7-1.4-1.2-2.3-1.2-2.3.5-4.6,1.2-6.7,1.8-.9.2-1.4,1.2-1.4,2.1l.2,7.4c0,.9-.5,1.6-1.2,1.8-1.2.7-2.3,1.2-3.2,1.8-.7.5-1.6.5-2.3,0l-6.4-3.7c-.7-.5-1.8-.5-2.5.2-1.6,1.6-3.5,3.2-4.8,5.1-.8.7-.8,1.7-.3,2.6l3.9,6.5c.5.7.5,1.6,0,2.3-.7,1.2-1.4,2.3-1.8,3.5-.5.7-1.2,1.2-1.8,1.2h-7.5c-.9,0-1.6.7-2.1,1.4-.7,2.3-1.4,4.4-1.6,6.7-.2.9.2,1.8,1.2,2.3l6.5,3.5c.7.5,1.2,1.2,1.2,1.8v3.6c0,.9-.5,1.6-1.2,2.1l-6.5,3.7c-.7.5-1.2,1.4-1.2,2.3.5,2.3,1.2,4.6,1.8,6.7.2.9,1.2,1.4,2.1,1.4l7.4-.2c.9,0,1.6.5,1.8,1.2.7,1.2,1.2,2.3,1.8,3.2.5.7.5,1.6,0,2.3l-3.7,6.5c-.5.7-.5,1.8.2,2.5,1.6,1.6,3.2,3.5,5.1,4.8.7.7,1.6.7,2.5.2l6.5-3.9c.7-.5,1.6-.5,2.3,0,1.2.7,2.3,1.4,3.5,1.8.7.5,1.2,1.2,1.2,1.8v7.4c0,.9.7,1.6,1.4,2.1,2.3.7,4.4,1.4,6.7,1.6.9.2,1.8-.2,2.3-1.2l3.5-6.5c.5-.7,1.2-1.2,1.8-1.2h3.6c.9,0,1.6.5,2.1,1.2l3.7,6.5c.5.7,1.4,1.2,2.3,1.2,2.3-.5,4.6-1.2,6.7-1.8.9-.2,1.4-1.2,1.4-2.1l-.2-7.4c0-.9.5-1.6,1.2-1.8,1.2-.7,2.3-1.2,3.2-1.8.7-.5,1.6-.5,2.3,0l6.5,3.7c.7.5,1.8.5,2.5-.2,1.6-1.6,3.5-3.2,4.8-5.1.7-.7.7-1.6.2-2.5l-3.9-6.5c-.5-.7-.5-1.6,0-2.3.7-1.2,1.4-2.3,1.8-3.5.5-.7,1.2-1.2,1.8-1.2h7.4c.9,0,1.6-.7,2.1-1.4.7-2.3,1.4-4.4,1.6-6.7,0-1-.4-1.9-1.1-2.4ZM54.7,127.9c-19.6,0-35.5-15.9-35.5-35.5s15.9-35.5,35.5-35.5,35.5,15.9,35.5,35.5c.3,19.6-15.6,35.5-35.5,35.5Z" />
                          </g>
                          <g id="gear-2">
                            <path d="M152,106.7c2.3-.2,4.6-.9,6.9-1.4.9-.2,1.4-1.2,1.6-1.8l.2-7.4c0-.9.5-1.6,1.4-1.8,1.2-.5,2.3-1.2,3.5-1.8.7-.5,1.6-.5,2.3,0l6.2,4.1c.7.5,1.8.5,2.5,0,1.8-1.4,3.5-3,5.3-4.6.7-.7.7-1.6.5-2.5l-3.5-6.7c-.5-.7-.2-1.6.2-2.3.7-1.2,1.4-2.1,2.1-3.2.5-.7,1.2-1.2,2.1-1.2l7.4.5c.9,0,1.8-.5,2.1-1.4.9-2.1,1.6-4.4,2.3-6.7.2-.9-.2-1.8-.9-2.3l-6.2-3.9c-.7-.5-1.2-1.2-.9-2.1,0-.7.2-1.4.2-1.8v-1.8c0-.9.5-1.6,1.2-1.8l6.7-3.2c.9-.5,1.4-1.4,1.2-2.3-.2-2.3-.9-4.6-1.4-6.9-.2-.9-1.2-1.4-1.8-1.6l-7.6-.2c-.9,0-1.6-.5-1.8-1.4-.5-1.2-1.2-2.3-1.8-3.5-.5-.7-.5-1.6,0-2.3l4.1-6.2c.5-.7.5-1.8,0-2.5-1.4-1.8-3-3.5-4.6-5.3-.7-.7-1.6-.7-2.5-.5l-6.7,3.5c-.7.5-1.6.2-2.3-.2-1.2-.7-2.1-1.4-3.2-2.1-.7-.5-1.2-1.2-1.2-2.1l.5-7.4c0-.9-.5-1.8-1.4-2.1-2.1-.9-4.4-1.6-6.7-2.3-.9-.2-1.8.2-2.3.9l-3.9,6.2c-.5.7-1.2,1.2-2.1.9-.7,0-1.4-.2-1.8-.2h-1.8c-.9,0-1.6-.5-1.8-1.2l-3.2-6.7c-.5-.9-1.4-1.4-2.3-1.2-2.3.2-4.6.9-6.9,1.4-.9.2-1.4,1.2-1.6,1.8l-.2,7.4c0,.9-.5,1.6-1.4,1.8-1.2.5-2.3,1.2-3.5,1.8-.7.5-1.6.5-2.3,0l-6.2-4.1c-.7-.5-1.8-.5-2.5,0-1.8,1.4-3.5,3-5.3,4.6-.7.7-.7,1.6-.5,2.5l3.5,6.7c.5.7.2,1.6-.2,2.3-.7,1.2-1.4,2.1-2.1,3.2-.5.7-1.2,1.2-2.1,1.2l-7.4-.5c-.9,0-1.8.5-2.1,1.4-.9,2.1-1.6,4.4-2.3,6.7-.2.9.2,1.8.9,2.3l6.2,3.9c.7.5,1.2,1.2.9,2.1,0,.7-.2,1.4-.2,1.8v1.8c0,.9-.5,1.6-1.2,1.8l-7,3.3c-.9.5-1.4,1.4-1.2,2.3.2,2.3.9,4.6,1.4,6.9.2.9,1.2,1.4,1.8,1.6l7.4.2c.9,0,1.6.5,1.8,1.4.5,1.2,1.2,2.3,1.8,3.5.5.7.5,1.6,0,2.3l-4.1,6.2c-.5.7-.5,1.8,0,2.5,1.4,1.8,3,3.5,4.6,5.3.7.7,1.6.7,2.5.5l6.7-3.5c.7-.5,1.6-.2,2.3.2,1.2.7,2.1,1.4,3.2,2.1.7.5,1.2,1.2,1.2,2.1l-.5,7.4c0,.9.5,1.8,1.4,2.1,2.1.9,4.4,1.6,6.7,2.3.9.2,1.8-.2,2.3-.9l3.9-6.2c.5-.7,1.2-1.2,2.1-.9.7,0,1.4.2,1.8.2h1.8c.9,0,1.6.5,1.8,1.2l3.2,6.7c1,.6,1.9,1.3,2.8,1.1h0ZM143.2,91.7c-19.6-.9-34.8-17.5-33.9-37.1s17.5-34.8,37.1-33.9c19.6.9,34.8,17.5,33.9,37.1-.6,19.6-17.2,34.8-37.1,33.9h0Z" />
                          </g>
                        </g>
                        <g id="ARROWS">
                          <g id="gear-arrow-1">
                            <path id="arrow-1" d="M81.3,92.6c0,14.7-11.9,26.6-26.6,26.6s-26.6-11.9-26.6-26.6,10.8-25.4,24.5-26.5v3l7.7-4.5-7.7-4.6v3.4c-15.2,1.1-27.2,13.8-27.2,29.3s13.1,29.3,29.3,29.3,29.3-13.1,29.3-29.3h-2.7Z" />
                            <rect className="arrow-spacer" x="52.7" y="124.6" width=".7" height=".7" transform="translate(106 250) rotate(180)" />
                          </g>
                          <g id="gear-arrow-2" data-name="gear-arrow-1">
                            <path id="arrow-2" data-name="arrow-1" d="M118.6,56.8c0,14.7,11.9,26.6,26.6,26.6s26.6-11.9,26.6-26.6-10.8-25.4-24.5-26.5v3s-7.7-4.5-7.7-4.5l7.7-4.6v3.4c15.2,1.1,27.2,13.8,27.2,29.3s-13.1,29.3-29.3,29.3-29.3-13.1-29.3-29.3h2.7Z" />
                            <rect className="arrow-spacer" data-name="spacer" x="146.6" y="88.8" width=".7" height=".7" />
                          </g>
                        </g>
                      </svg>
                    </div>

                    React App Development

                  </div>
                  <div className="flip-card-back">
                    <h3>React App <span>Development</span></h3>
                    <p>Experienced in building React applications and Single Page Applications (SPAs) using custom, reusable components. Additionally, skilled in modern headless WordPress development, leveraging Next.js to deliver high-performance front ends connected to dynamic content backends.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num"> 4+</div>
                      Years' Experience
                    </div>
                  </div>
                </div>
              </div>




              <div className="flip-card fc6">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc6">




                    <div className="fc-icon">
                      <svg id="design-3d-modeling-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 80.8 68">
                        <path d="M80.8,14.4s0,0,0,0c0-.1,0-.3-.1-.4,0,0,0,0,0,0,0-.1-.1-.2-.2-.3,0,0,0,0,0,0,0-.1-.2-.2-.3-.3,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2-.1-.3-.2,0,0,0,0,0,0,0,0,0,0,0,0L41,.1c-.4-.1-.8-.1-1.3,0L1.4,12.9s0,0,0,0c0,0,0,0,0,0-.1,0-.2.1-.3.2,0,0,0,0,0,0,0,0,0,0,0,0-.1,0-.2.2-.3.3,0,0,0,0,0,0,0,.1-.2.2-.2.3,0,0,0,0,0,0,0,.1-.1.3-.1.4,0,0,0,0,0,0,0,.1,0,.3,0,.4v38.4c0,.9.5,1.6,1.4,1.9l38.4,12.8s0,0,0,0c0,0,.1,0,.2,0,0,0,0,0,.1,0,.1,0,.2,0,.3,0s.2,0,.3,0c0,0,0,0,.1,0,0,0,.1,0,.2,0,0,0,0,0,0,0l38.4-12.8c.8-.3,1.4-1,1.4-1.9V14.8c0-.1,0-.3,0-.4ZM40.4,25.5L8.2,14.8,40.4,4.1l32.2,10.7-32.2,10.7ZM76.9,51.8l-34.5,11.5V29l16.5-5.5,18-6v34.3ZM4,17.5l34.5,11.5v34.3L4,51.8V17.5Z" />
                        <path d="M20.1,37.3h1.6l1.2,2,1.3-2h1.5l-2,3,2.2,3.2h-1.6l-1.4-2.1-1.4,2.1h-1.5l2.2-3.3-2-3Z" />
                        <path d="M56.7,37.3h1.5l1.5,2.5,1.4-2.5h1.5l-2.3,3.8v2.4h-1.4v-2.4l-2.3-3.8Z" />
                        <path d="M40.3,12.9h-2.8v-1h4.4v1l-3,3.6h3.1v1h-4.8v-1l3-3.6Z" />
                      </svg>
                    </div>

                    3D Design &amp; Modeling

                  </div>
                  <div className="flip-card-back">

                    <h3>3D Design <span>&amp; Modeling</span></h3>
                    <p>Experienced with 3D design and modeling in 3D Studio Max and Blender creating custom models, setting-up lighting, adding custom textures, rendering and animatiion.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num">18+</div>
                      Years' Experience
                    </div>
                  </div>
                </div>
              </div>



              <div className="flip-card fc7">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc7">

                    <div className="fc-icon">
                      <svg id="video_editing_icon" version="1.1" viewBox="0 0 200 165">
                        <path d="M111.3,63.1h13.1c-3.5-3.5-15.7-15.4-19.6-19.3,13.3,0,26.2,0,39,0,.2-.3-2.8-3.6-5.1-5.5-2.9-2.3-6.1-2.6-9.8-2.8-10.4-.5-20.8-.4-31.2-.6-1.3,0-2.8-.5-3.7-1.3-4.4-3.9-8.7-7.9-12.9-11.9-.5-.5-.7-2-.4-2.4,5.5-6,.9-15-6.6-16.9-5.1-1.3-10.5,1-12.5,5.5-2,4.4,0,10.1,4.6,12.8,1.4.8,3,1.3,4.4,2.1,3.5,2,7,3.9,10.3,6.2,2.3,1.6,4.5,4,3.2,6.9-1.2,2.7-4.3,3-7,2.5-4.6-.9-9.1-2.4-13.7-3.5-2-.5-4.1-1.1-6.2-1-3.8.2-6.8,2-8.4,5.6-1.6,3.5-1.1,6.8,1.3,9.9,3,3.9,7.9,5.8,12.3,4.7,5.2-1.3,7.7-4.8,7.9-10,7,0,13.6,0,20.3,0,.8,0,1.8.8,2.5,1.4,3.2,3,15,14.5,18.2,17.6,0,0,0,0,0,0ZM72.4,17.8c-3.5,0-7-3.3-6.9-6.3,0-2.7,2.5-4.6,5.7-4.6,3.5,0,7.1,3.2,7,6.3,0,2.6-2.7,4.7-5.7,4.7ZM59.6,49.4c-3.5,0-7.1-3.3-6.9-6.3.1-2.6,2.6-4.6,5.8-4.6,3.5,0,7,3.3,6.9,6.3,0,2.6-2.6,4.7-5.7,4.6Z" />
                        <path d="M28.6,61.9v103.1h142.8V61.9H28.6ZM140.4,66.1h9v9h-9v-9ZM122.4,66.1h9v9h-9v-9ZM104.5,66.1h9v9h-9v-9ZM86.5,66.1h9v9h-9v-9ZM68.6,66.1h9v9h-9v-9ZM50.7,66.1h9v9h-9v-9ZM32.7,66.1h9v9h-9v-9ZM41.7,160.9h-9v-9h9v9ZM59.6,160.9h-9v-9h9v9ZM77.6,160.9h-9v-9h9v9ZM95.5,160.9h-9v-9h9v9ZM113.5,160.9h-9v-9h9v9ZM131.4,160.9h-9v-9h9v9ZM149.3,160.9h-9v-9h9v9ZM167.3,160.9h-9v-9h9v9ZM167.3,147.8H32.7v-68.6h134.5v68.6ZM167.3,75h-9v-9h9v9Z" />
                      </svg>
                    </div>

                    Video Editing  &amp; Publishing

                  </div>
                  <div className="flip-card-back">
                    <h3>Video Editing <span>&amp; Publishing</span></h3>
                    <p>Experienced with editing of video segments, filtering, adding captions, custom caption boards, masking, transitions and visual effects. Specialzing in output formats for specific social media venues like Facebook, Instagram, Vimeo and Youtube.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num">14+</div>
                      Years' Experience
                    </div>
                  </div>
                </div>
              </div>



              <div className="flip-card fc8">
                <div className="flip-card-cont">
                  <div className="flip-card-front" data-card-id="fc8">


                    <div className="fc-icon">
                      <svg id="rocket-icon" version="1.1" viewBox="0 0 200 130">
                        <path className="st0" d="M71,83.6c-8.4,2-18.5,4.8-23.7,7.7-9.7,5.7-26.8,26.8-26.8,26.8,0,0,24.7-3.4,36.4-10.2,5.1-2.9,12.6-10.4,18.4-16.8l-4.4-7.5h0ZM67.1,94.7c-1.8,1.8-3.8,3.6-5.8,5.3-2.3,2-4.5,3.7-6.3,4.8-7.6,4.2-23.7,6.6-23.7,6.6,0,0,11.3-12.6,17.7-16l.7-.2c3.6-1.7,9.6-3.4,14.8-4.7l2.7,4.3h0Z" />
                        <path className="st0" d="M146.9,36.5c-2-3-15.5-2.5-30.1,2.2-4.2,1.2-8.3,2.9-12.4,5-9.2,4.6-17,11.5-22.9,18-4.3-5.1-11.8-10.6-19-2.5-5.5,6.6-10.2,16.3-12.7,21.6-.5,1.1-.7,1.5,1.7,1.4,4.1-4.5,15.2-12.5,21.1-9.6-1.7,2.6-2.7,4.1-2.7,4.1l4,6,14.1-10.7c.8-.7,2.1-.2,2.9.9l2.2,3.4c.7,1.1.7,2.5-.3,3l-15.2,9.1,3.9,5.8s1.5-.2,4-.8c-1,6.1-11.3,12.8-16.6,14.6-.9,2.2-.5,2.1.6,2.1,5.7-.3,16.6-1.1,24.9-3.7,9.5-3.3,8.1-11.2,5.5-17.2,8.2-3,17.7-7.8,25.3-14.8,14.9-13.8,24-34.3,21.4-38.1h0l.3.2ZM112.8,79.4c-3.1,1.6-6.2,3.1-9.1,4.2-.3-1.2-1.7-6-5.5-11.5-3.4-4.9-8-9.5-9.8-11.3,2.1-2.2,4.3-4.3,6.9-6.5,1.3.9,6.9,4.7,11.7,11.9,4.7,6.9,5.7,11.9,5.8,13.2ZM131.8,61.7c-1.7,2.5-3.7,4.8-5.8,7.2-.5-1.8-2.9-7.5-6.1-12.2-3.3-4.8-8.9-9.7-10.4-11,2-.9,4.2-1.6,6.2-2.2l3.1-.9c1.5,1,5.1,3.7,8.8,9.1,3.4,5.2,4,8.6,4.2,10h0Z" />
                        <g id="rocket-center-fin">
                          <path className="st0" d="M59.7,96.9h0c-.4-.5,0-1.4.7-1.9l27.6-19.9c.8-.6,1.8-.5,2.1,0l1.1,1.8c.4.5,0,1.5-.8,2l-28.8,18.3c-.7.4-1.5.4-1.9-.2h0Z" />
                        </g>
                        <g id="rocket-stars">
                          <polygon className="st0" points="129.1 12.3 133 15.2 137.7 13.6 136.2 18.3 139 22.4 134 22.2 131.2 26.3 129.7 21.6 125 19.9 129.2 17.2 129.1 12.3" />
                          <polygon className="st0" points="165.3 12.4 169.6 20.1 178.3 20.9 172.2 27.3 174.2 35.9 166.3 32.2 158.7 36.7 159.7 27.9 153.2 22.1 161.8 20.4 165.3 12.4" />
                          <polygon className="st0" points="150.4 59.8 154.4 59.3 156.1 55.6 157.9 59.3 161.8 59.9 159 62.6 159.6 66.6 156.1 64.7 152.5 66.6 153.3 62.6 150.4 59.8" />
                        </g>
                      </svg>
                    </div>

                    Animation

                  </div>
                  <div className="flip-card-back">

                    <h3>Animation</h3>
                    <p> Experienced with GIF animations, cartoon animations, JavaScript and CSS animations, GSAP animations, PixiJS animations, canvas animations,  Adobe Animate and After Effects animations, particle animations and 3D animations.</p>
                    <div className="years-exp-badge">
                      <div className="badge-num">22+</div>
                      Years' Experience
                    </div>
                  </div>
                </div>
              </div>

            </div>



            <svg id="lens-flare-1" viewBox="0 0 512.4 512.4">
              <defs>
                <radialGradient id="radial-gradient" cx="256.2" cy="256.2" fx="256.2" fy="256.2" r="250" gradientUnits="userSpaceOnUse">
                  <stop offset=".8" stopColor="#ec8d1d" stopOpacity=".2" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity="0" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity="0" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity=".2" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity=".2" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity=".2" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity=".2" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity=".2" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity=".2" />
                  <stop offset=".8" stopColor="#f7931e" stopOpacity=".1" />
                  <stop offset=".8" stopColor="#f7931e" />
                  <stop offset=".9" stopColor="#29abe2" />
                  <stop offset=".9" stopColor="aqua" stopOpacity="0" />
                </radialGradient>
              </defs>
              <circle className="lf-1" cx="256.2" cy="256.2" r="250" />
            </svg>

            <svg id="lens-flare-2" viewBox="0 0 512.4 512.4">
              <circle className="lf-2" cx="256.2" cy="256.2" r="256.2" />
            </svg>

            <svg id="lens-flare-3" viewBox="0 0 512.4 512.4">
              <circle className="lf-3" cx="256.2" cy="256.2" r="256.2" />
            </svg>

          </div>

        </section>





        <section className="software-skills">

          <div className="skillgauge-display-wrapper">
            <h2><span className="h2-Title">Software Experience</span></h2>
            <SkillGauge />
            <div className="skillguage-tag">skillGauge by MH</div>
          </div>
        </section>

        <section className="coding-skills">
          <div className="skillgauge-display-wrapper">
            <h2><span className="h2-Title">Coding Experience</span></h2>
            <SkillGauge2 />
            <div className="skillguage-tag">skillGauge by MH</div>
          </div>
        </section>










   
          <section className="education-and-other-talents">


            <h2><span className="h2-Title">Education &amp; Knowledge</span></h2>


            <div className="laptop-edu-books-wrapper">


              <div className="laptop-container-wrapper">
                <div className="laptop-container">
                  <div className="screen">
                    {/* Absolute Positioned logo - top */}

                    <svg id="mhd-logo" className="screen-mhd-logo" version="1.1" viewBox="0 0 223.2 152.8">
                      <polygon id="stripe-5" points="200 105.6 200 128 177.7 128 152.8 152.8 191.3 152.8 223.2 120.9 223.2 82.4 200 105.6" />
                      <g id="stripe-4">
                        <polygon id="s4c" points="156.7 85.5 156.7 118.5 173.2 102.1 173.2 85.5 156.7 85.5" />
                        <polygon id="s4b" points="223.2 13.6 200 36.8 200 75.2 223.2 52.1 223.2 13.6" />
                        <polygon id="s4a" points="129.9 106.9 123.8 113 123.8 128 108.8 128 83.9 152.8 122.4 152.8 147.3 128 129.9 128 129.9 106.9" />
                      </g>
                      <g id="stripe-3">
                        <polygon id="s3c" points="129.9 38.1 123.8 44.2 123.8 82.6 129.9 76.5 129.9 38.1" />
                        <polygon id="s3b" points="156.7 24.9 156.7 49.7 173.2 33.2 173.2 24.9 181.5 24.9 206.4 0 167.9 0 143 24.9 156.7 24.9" />
                        <polygon id="s3a" points="64.8 128 60.9 107.1 50.2 117.8 50.2 128 40 128 15.1 152.8 53.6 152.8 78.5 128 64.8 128" />
                      </g>
                      <g id="stripe-2">
                        <polygon id="s2c" points="70.9 66.7 79.5 58.1 85.4 24.9 112.7 24.9 137.6 0 99.1 0 65.1 34 70.9 66.7" />
                        <polygon id="s2b" points="25.1 74 0 99.1 0 137.5 25.1 112.5 25.1 74" />
                        <polygon id="s2a" points="56.1 81.5 50.5 51.2 50.2 51.2 50.2 87.4 56.1 81.5" />
                      </g>
                      <polygon id="stripe-1" points="25.1 24.9 43.8 24.9 68.7 0 30.2 0 0 30.2 0 68.7 25.1 43.7 25.1 24.9" />
                      <path id="initials-bg" d="M20.1,19.8v113.1h184.8V19.8H20.1ZM123.8,128h-25.1V51.2h-.3l-14.3,76.8h-19.3l-14.3-76.8h-.3v76.8h-25.1V24.9h38.4l10.8,61.1h.3l10.8-61.1h38.4v103.1h0ZM200,128h-26.8v-42.5h-16.5v42.4h-26.8V24.9h26.8v37.8h16.5V24.9h26.8v103.1Z" />
                    </svg>

                    {/* Absolute Positioned signal - middle */}
                    <div id="signal-notice-wrap">
                      <svg id="signal-notice" baseProfile="tiny" version="1.2" viewBox="0 0 876.7 876.7">
                        <g className="signal-notice">
                          <path className="signal-hoop-1" d="M438.3,255c-101.3,0-183.3,82.1-183.3,183.3s82.1,183.3,183.3,183.3,183.3-82.1,183.3-183.3-82.1-183.3-183.3-183.3ZM438.3,593.3c-85.6,0-155-69.4-155-155s69.4-155,155-155,155,69.4,155,155-69.4,155-155,155Z" />
                          <path className="signal-hoop-2" d="M438.3,133.3c-168.4,0-305,136.6-305,305s136.6,305,305,305,305-136.6,305-305-136.6-305-305-305ZM438.3,721.7c-156.5,0-283.3-126.9-283.3-283.3s126.9-283.3,283.3-283.3,283.3,126.9,283.3,283.3-126.9,283.3-283.3,283.3Z" />
                          <path className="signal-hoop-3" d="M438.3,0C196.2,0,0,196.2,0,438.3s196.2,438.3,438.3,438.3,438.3-196.2,438.3-438.3S680.4,0,438.3,0ZM438.3,858.3c-232,0-420-188-420-420S206.4,18.3,438.3,18.3s420,188,420,420-188,420-420,420Z" />
                        </g>
                      </svg>
                    </div>


                    <img className="screen-top" src={laptop_screen} alt="laptop screen" />
                  </div>



                  <img className="base" src={laptop_base} alt="laptop base" />




            <div className="edu-paragraph">
              <p><span className="bullet-edu"></span> South Miami High School</p>
              <p><span className="bullet-edu"></span> Over 20 years of agency and client experience</p>
              <p><span className="bullet-edu"></span> Self-taught — books, online courses, reverse-engineering</p>
            </div>

                </div>
              </div>




  <div className="education-bg-grid-wrapper">
    <div className="education-bg-grid">
      <div className="grid-block">
        <div className="gb-box gb-1">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>
      <div className="grid-block">
        <div className="gb-box gb-2">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-3">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-4">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-5">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-6">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-7">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-8">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-9">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-10">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-11">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer"/>
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-12">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-13">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-14">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-15">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

      <div className="grid-block">
        <div className="gb-box gb-16">
          <div className="gb-back"></div>
          <div className="gb-front"></div>
          <img src={grid_spacer}  alt="grid spacer" />
        </div>
      </div>

    </div>
  </div>








  

            </div>





          </section>


      











      </div>
    </main>

  );

};
export default About;


